import { render, staticRenderFns } from "./TnC.vue?vue&type=template&id=ddf5498e&scoped=true"
import script from "./TnC.vue?vue&type=script&lang=js"
export * from "./TnC.vue?vue&type=script&lang=js"
import style0 from "./TnC.vue?vue&type=style&index=0&id=ddf5498e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf5498e",
  null
  
)

export default component.exports